import { render, staticRenderFns } from "./PromoWinners.vue?vue&type=template&id=1a976b0a&scoped=true&"
import script from "./PromoWinners.vue?vue&type=script&lang=js&"
export * from "./PromoWinners.vue?vue&type=script&lang=js&"
import style0 from "./PromoWinners.vue?vue&type=style&index=0&id=1a976b0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a976b0a",
  null
  
)

export default component.exports